<div class="row">
  <div class="col-sm-12">
    <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.Payment.Title' | translate}}</h2>
  </div>
</div>

<div class="row">
  <!--Conta bancária-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="isNotStateRLDiferido()">
        <label [class.disabled]="isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!isNotStateRLDiferido()">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.Payment.Fields.BankAccount' | translate}}
          <span  class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberPaymentInfo.BankAccountType' | translate}}"></span>
        </label>
        <select class="custom-select"
                [(ngModel)]="cardData.bankAccount"
                name="bankAccount"
                [required]="!isNotStateRLDiferido()"
                #bankAccount="ngModel"
                nullableSelect
                (change)="onBankAccountChanged()"
                [clearRelated]="{model : this.cardData , propsToReset : ['iban','isSoleHolder','coholderName']} "
                [dropdownTitle]="{value : cardData.bankAccount, dimensions : bankAccountTypes }">
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of bankAccountTypes" [value]="domain.code"  [disabled]="(countryCode!='PT' && countryCode != null && countryCode != undefined)  && domain.code === 'N'"
                  [ngStyle]="{'font-weight': (countryCode!='PT' && countryCode != null && countryCode != undefined) && domain.code === 'I' ? 'bold' : 'normal'}"  >
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="bankAccount"></validation-message>
      </fieldset>
    </div>
  </div>
  <!--<span>countryCode:{{countryCode}}</span>-->

  <!-- IBAN da conta bancária -->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="cardData.bankAccount != 'N' || isNotStateRLDiferido()">
        <label [class.disabled]="cardData.bankAccount != 'N' || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(cardData.bankAccount != 'N' || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.Payment.Fields.IBAN' | translate}}
          <span  class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberPaymentInfo.Iban' | translate}}"></span>
        </label>
        <input class="form-control" type="text"
               placeholder="{{'Placeholders.CardSubscriberPaymentInfo.Iban' | translate}}"
               [(ngModel)]="cardData.iban" #iBAN="ngModel" name="iBAN"
               
               [required]="!(cardData.bankAccount != 'N' || isNotStateRLDiferido())"
               ibanValidation
               [pattern]="cardData.bankAccount == 'N' ? '^(PT|pt|Pt|pT)50.*' : ''" maxlength="30">
        <validation-message [control]="iBAN"></validation-message>
      </fieldset>
    </div>
  </div>

  <!-- Único titular? -->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="cardData.bankAccount !== 'N' || isNotStateRLDiferido()">
        <label [class.disabled]="cardData.bankAccount !== 'N' || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(cardData.bankAccount !== 'N' || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.Payment.Fields.SoleHolder' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth"  style="height:69px;">
          <label *ngFor="let domain of yesNo.slice().reverse()"
                 tabindex="0" class="btn btn-toogle"
                 [class.active]="domain.value==cardData.isSoleHolder?.toString()"
                 [radioLabel]="isSoleHolder">
            <input type="radio"
                   [(ngModel)]="cardData.isSoleHolder"
                   #isSoleHolder="ngModel"
                   name="isSoleHolder"
                   [value]="domain.value"
                   [required]="!(cardData.bankAccount !== 'N' || isNotStateRLDiferido())"
                   [clearRelated]="{model : this.cardData , propsToReset : ['coholderName']} ">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>  
      </fieldset>
    </div>
  </div>
</div>

<div class="row">
  <!-- Cotitular/Autorizado -->
  <div class="col-sm-8">
    <div class="form-group">
      <fieldset>
        <label for="coholderName" [class.disabled]="cardData.isSoleHolder?.toString() != 'false'  || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(cardData.isSoleHolder?.toString() != 'false'  || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.Payment.Fields.CoholderName' | translate}}
        </label>
        <input class="form-control"
               type="text"
               maxlength="60"
               placeholder="{{'Placeholders.CardSubscriberPaymentInfo.CoOwner' | translate}}"
               [(ngModel)]="cardData.coholderName"
               #coholderName="ngModel"
               name="coholderName"
               [required]="!(cardData.isSoleHolder?.toString() != 'false'  || isNotStateRLDiferido())"
               [disabled]="cardData.isSoleHolder?.toString() != 'false'  || isNotStateRLDiferido()">
      </fieldset>
      <validation-message [control]="coholderName"></validation-message>

    </div>
  </div>
</div>
